<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap3"><i>The Songs We Know Best</i></h1>
<p class="poem1" style="margin-top:30px;">Just like a shadow in an empty room</p>
<p class="poem1">Like a breeze that’s pointed from beyond the tomb</p>
<p class="poem1">Just like a project of which no one tells—</p>
<p class="poem1">Or didja really think that I was somebody else?</p>
<p class="poem1" style="margin-top:20px;">Your clothes and pantlegs lookin’ out of shape</p>
<p class="poem1">Shape of the body over which they drape</p>
<p class="poem1">Body which has acted in so many scenes</p>
<p class="poem1">But didja ever think of what that body means?</p>
<p class="poem1" style="margin-top:20px;">It is an organ and a vice to some</p>
<p class="poem1">A necessary evil which we all must shun</p>
<p class="poem1">To others an abstraction and a piece of meat</p>
<p class="poem1">But when you’re looking out you’re in the driver’s seat!</p>
<p class="poem1" style="margin-top:20px;">No man cares little about fleshly things</p>
<p class="poem1">They fill him with a silence that spreads in rings</p>
<p class="poem1">We wish to know more but we are never sated</p>
<p class="poem1">No wonder some folks think the flesh is overrated!</p>
<p class="poem1" style="margin-top:20px;">The things we know now all got learned in school</p>
<p class="poem1">Try to learn a new thing and you break the rule</p>
<p class="poem1">Our knowledge isn’t much it’s just a small amount</p>
<p class="poem1">But you feel it quick inside you when you’re down for the count</p>
<p class="poem1" style="margin-top:20px;">You look at me and frown like I was out of place</p>
<p class="poem1">I guess I never did much for the human race</p>
<p class="poem1">Just hatched some schemes on paper that looked good at first</p>
<p class="poem1">Sat around and watched until the bubble burst</p>
<p class="poem1" style="margin-top:20px;">And now you’re lookin’ good all up and down the line</p>
<p class="poem1">Except for one thing you still have in mind</p>
<p class="poem1">It’s always there though often with a different face</p>
<p class="poem1">It’s the worm inside the jumping bean that makes it race</p>
<p class="poem1" style="margin-top:20px;">Too often when you thought you’d be showered with confetti</p>
<p class="poem1">What they flung at you was a plate of hot spaghetti</p>
<p class="poem1">You’ve put your fancy clothes and flashy gems in hock</p>
<p class="poem1">Yet you pause before your father’s door afraid to knock</p>
<p class="poem1" style="margin-top:20px;">Once you knew the truth it tried to set you free</p>
<p class="poem1">And still you stood transfixed just like an apple tree</p>
<p class="poem1">The truth it came and went and left you in the lurch</p>
<p class="poem1">And now you think you see it from your lofty perch</p>
<p class="poem1" style="margin-top:20px;">The others come and go they’re just a dime a dozen</p>
<p class="poem1">You react to them no more than to a distant cousin</p>
<p class="poem1">Only a few people can touch your heart</p>
<p class="poem1">And they too it seems have all gotten a false start</p>
<p class="poem1" style="margin-top:20px;">In twilight the city with its hills shines serene</p>
<p class="poem1">And lets you make of it more than anything could mean</p>
<p class="poem1">It’s the same city by day that seems so crude and calm</p>
<p class="poem1">You’ll have to get to know it not just pump its arm</p>
<p class="poem1" style="margin-top:20px;">Even when that bugle sounded loud and clear</p>
<p class="poem1">You knew it put an end to all your fear</p>
<p class="poem1">To all that lying and the senseless mistakes</p>
<p class="poem1">And now you’ve got it right and you know what it takes</p>
<p class="poem1" style="margin-top:20px;">Someday I’ll look you up when we’re both old and gray</p>
<p class="poem1">And talk about those times we had so far away</p>
<p class="poem1">How much it mattered then and how it matters still</p>
<p class="poem1">Only things look so different when you’ve got a will</p>
<p class="poem1" style="margin-top:20px;">It’s true that out of this misunderstanding could end</p>
<p class="poem1">And men would greet each other like they’d found a friend</p>
<p class="poem1">With lots of friends around there’s no one to entice</p>
<p class="poem1">And don’t you think seduction isn’t very nice?</p>
<p class="poem1" style="margin-top:20px;">It carries in this room against the painted wall</p>
<p class="poem1">And hangs in folds of curtains when it’s not there at all</p>
<p class="poem1">It’s woven in the flowers of the patterned spread</p>
<p class="poem1">And lies and knows not what it thinks upon the bed</p>
<p class="poem1" style="margin-top:20px;">I wish to come to know you get to know you all</p>
<p class="poem1">Let your belief in me and me in you stand tall</p>
<p class="poem1">Just like a project of which no one tells—</p>
<p class="poem1">Or do ya still think that I’m somebody else?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 7chap3.vue?08fdf0f5